import apiClient from './api';

// 30 ago 2026 (pedido de Augusto: "lo que se necesita es la meta, que no
// está definida"): meta de ahorro mensual + largo plazo -- ver
// backend_new/app/api/v1/endpoints/savings_goal.py para el contrato
// completo. Una sola meta por usuario (no una lista), por eso no hay
// getAll/create/delete como en budgetService -- get siempre devuelve algo
// (el backend la crea vacía la primera vez que se pide) y update
// reemplaza los campos que se le manden.
const goalService = {
  get: async () => apiClient.get('/savings-goal'),
  update: async (data) => apiClient.put('/savings-goal', data),
  getProgress: async () => apiClient.get('/savings-goal/progress'),
};

export default goalService;
